import { type FC } from 'react'

const FieldWithIcon: FC<{ icon: React.ReactNode; data: React.ReactNode }> = ({ icon, data }) => {
  return (
    <div className={`flex`}>
      <div className="flex text-[14px] w-12.5 justify-center pt-0.75 shrink-0">{icon}</div>
      <span className={`dark:text-white`}>{data}</span>
    </div>
  )
}

export default FieldWithIcon
